module.exports = __webpack_public_path__ + "static/img/resume.0cff715.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specialist/resume.png
// module id = pxyg
// module chunks = 1